module.exports = __webpack_public_path__ + "img/review-full.4f1503e3.svg";